/**
 * Sticky Footer Handler
 *
 * @package DesignSchool\Forms
 */

declare var jQuery: any;
declare var dsFormsConfig: any;

export class StickyFooter {
    private $: any;
    private $footer: any;

    constructor() {
        this.$ = jQuery;
        this.init();
    }

    /**
     * Initialize
     */
    private init(): void {
        this.$footer = this.$('.ds-sticky-footer');

        if (!this.$footer.length) {
            return;
        }

        // Add body class
        this.$('body').addClass('has-ds-sticky-footer');

        // Setup click handlers
        this.setupClickHandlers();

        // Adjust cookie modal
        this.adjustCookieModal();

        // Mobile protection (from legacy header.php:62-72)
        if (window.matchMedia('(max-width: 991px)').matches) {
            this.protectMobileButton();
        }
    }

    /**
     * Setup click handlers
     */
    private setupClickHandlers(): void {
        // Grey button (consultation), в т.ч. FAB на мобиле
        this.$footer.find('.ds-form-opener--grey, .ds-sticky-footer__consult-fab').on('click', (e: Event) => {
            e.preventDefault();
            this.trackMetrikaGoal('poluchitkonsultaciyu');
        });

        // Green button (application)
        this.$footer.find('.ds-form-opener--green').on('click', (e: Event) => {
            e.preventDefault();
            this.trackMetrikaGoal('zayavkanaobuchenie');
        });
    }

    /**
     * Track Yandex Metrika goal
     */
    private trackMetrikaGoal(goal: string): void {
        const metrikaId = dsFormsConfig?.yandexMetrikaId || '';
        if (!metrikaId) {
            return;
        }

        const yaCounter = (window as any)[`yaCounter${metrikaId}`];
        if (typeof yaCounter !== 'undefined') {
            yaCounter.reachGoal(goal);
            console.log('[StickyFooter] Metrika goal:', goal);
        }
    }

    /**
     * Adjust cookie modal position
     */
    private adjustCookieModal(): void {
        setTimeout(() => {
            const modal = this.$('#cookie-modal');
            const stickyFooter = this.$('.ds-sticky-footer');
            const btnGreen = this.$('.ds-sticky-footer .ds-form-opener--green');

            if (modal.length && (!stickyFooter.length || !btnGreen.length)) {
                modal.addClass('sticky-footer-no');
            }
        }, 1000);
    }

    /**
     * Protect mobile button from accidental removal
     * From legacy: header.php:62-72
     */
    private protectMobileButton(): void {
        const protectedSel = '.ds-sticky-footer .ds-form-opener--green';

        const isProtected = (node: Node): boolean => {
            if (!node || node.nodeType !== 1) return false;
            
            const element = node as HTMLElement;
            
            if (element.matches && element.matches(protectedSel)) return true;
            if (element.querySelector && element.querySelector(protectedSel)) return true;
            
            return false;
        };

        // Observe DOM mutations
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.removedNodes.forEach((node) => {
                    if (isProtected(node)) {
                        console.warn('[StickyFooter] Protected button removal blocked');
                        // Re-add if removed
                        // (Implementation depends on specific needs)
                    }
                });
            });
        });

        // Start observing
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    /**
     * Show sticky footer
     */
    public show(): void {
        this.$footer.fadeIn(300);
    }

    /**
     * Hide sticky footer
     */
    public hide(): void {
        this.$footer.fadeOut(300);
    }

    /**
     * Update buttons
     */
    public updateButtons(formIds: string[]): void {
        // TODO: Implement dynamic button update
        console.log('[StickyFooter] Update buttons:', formIds);
    }
}

// Export singleton
export const stickyFooter = new StickyFooter();

